module.exports = __webpack_public_path__ + "static/media/Technologyicon02@2x.1658223e.png";